/**
 * "Is it this person's turn on the project?" (ENG-117)
 *
 * The server sends current_assignee_ids: everyone on the current step (all assignees of a
 * shared task, and every open task of an unordered current section). current_assignee_id
 * stays as the single display/grouping value. Older cached payloads lack the list, so fall
 * back to the single field there.
 */
export interface CurrentAssigneeFields {
  current_assignee_id?: string | null;
  current_assignee_ids?: string[] | null;
}

export function isCurrentAssignee(p: CurrentAssigneeFields, userId: string | null | undefined): boolean {
  if (!userId) return false;
  if (Array.isArray(p.current_assignee_ids)) return p.current_assignee_ids.includes(userId);
  return p.current_assignee_id === userId;
}

export function hasNoCurrentAssignee(p: CurrentAssigneeFields): boolean {
  if (Array.isArray(p.current_assignee_ids)) return p.current_assignee_ids.length === 0;
  return !p.current_assignee_id;
}
